import { memo, useState } from "react";
import { Box, Paper, Stack } from "@mui/material";
import { TeleconsultoriaDateFilter } from "../../shared/components/TeleconsultoriaDateFilter";
import { useTeleconsultoriaDateRange } from "../../shared/hooks/useTeleconsultoriaDateRange";
import { useOrganizationProfessionalOptions } from "../hooks/useOrganizationProfessionalOptions";
import { useProviderClinicActivity } from "../hooks/useProviderClinicActivity";
import { BookedTeleconsultoriasSection } from "./BookedTeleconsultoriasSection";
import { ProfessionalFilterSelect } from "./ProfessionalFilterSelect";
import { ProviderInvitesSection } from "./ProviderInvitesSection";
import { TeamAvailabilitySection } from "./TeamAvailabilitySection";

/**
 * Visão CLÍNICA da prestadora — atividade:
 * filtros (período + profissional) valem para marcadas, convites e disponibilidade.
 * Desktop: marcadas e convites à esquerda, disponibilidade à direita. Mobile: empilhado.
 */
export const ClinicActivityView = memo(function ClinicActivityView() {
  const range = useTeleconsultoriaDateRange("day");
  const [professionalReference, setProfessionalReference] = useState("");
  const professionalOptions = useOrganizationProfessionalOptions();
  const { inviteRows, bookedRows, isLoading, hasError, reload } = useProviderClinicActivity(
    range,
    professionalReference,
  );

  return (
    <Stack spacing={2} width="100%">
      <Paper variant="outlined" sx={{ p: 1.5 }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          alignItems={{ md: "center" }}
          justifyContent="space-between"
        >
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <TeleconsultoriaDateFilter range={range} />
          </Box>
          <ProfessionalFilterSelect
            options={professionalOptions}
            value={professionalReference}
            onChange={setProfessionalReference}
          />
        </Stack>
      </Paper>
      <Box
        sx={{
          display: "grid",
          gap: 3,
          alignItems: "start",
          gridTemplateColumns: { xs: "1fr", md: "minmax(0, 2fr) minmax(260px, 1fr)" },
        }}
      >
        <Stack spacing={3} sx={{ minWidth: 0 }}>
          <BookedTeleconsultoriasSection
            rows={bookedRows}
            isLoading={isLoading}
            hasError={hasError}
            onRefresh={reload}
          />
          <ProviderInvitesSection
            rows={inviteRows}
            isLoading={isLoading}
            hasError={hasError}
            onRefresh={reload}
          />
        </Stack>
        <Box sx={{ minWidth: 0 }}>
          <TeamAvailabilitySection professionalReference={professionalReference || undefined} />
        </Box>
      </Box>
    </Stack>
  );
});
